import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'funnels-management',
  storeModule.createStoreModule('funnels-management', {
    fetchFiltersURL: 'settings/funnels'
  })
)
